<template>
  <ValidationObserver v-slot="{ invalid }">
    <!-- Login Form -->
    <form
      class="chi-form"
      key="login"
      @submit.prevent="resetPassword"
      id="reset-form"
    >
      <div class="px-5 pt-6 pb-8 mb-4 flex flex-col my-2">
        <ChiInput
          type="email"
          rules="required"
          label="Your Email"
          name="email"
          placeholder="Your email address"
          v-model="email"
        />

        <ChiInput
          type="password"
          rules="required|passwordPolicy"
          label="New Password"
          name="password"
          placeholder="*********"
          v-model="password"
        />

        <ChiInput
          type="password"
          rules="required|passwordCheck:@password"
          label="New Password Confirmation"
          name="confirmation"
          placeholder="*********"
          v-model="confirmPassword"
        />

        <div class="flex items-center justify-between">
          <input
            type="submit"
            :disabled="invalid"
            class="btn btn-purple"
            value="Confirm"
          />
        </div>
      </div>
    </form>

    <PageLoading v-if="loading" />
  </ValidationObserver>
</template>

<script>
import ChiInput from "@/components/Forms/ChiInput.vue";

export default {
  name: "LoginForm",
  components: {
    ChiInput,
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      token: "",
      email: "",
      loading: false,
    };
  },
  methods: {
    resetPassword() {
      this.loading = true;
      this.$store
        .dispatch("resetUserPassword", {
          email: this.email,
          username: this.userName,
          password: this.password,
          token: this.token,
        })
        .then(() => {
          this.$toasted.global.notificate({
            message: "Password updated. Redirecting to Login page",
            type: "success",
          });

          this.$router.push({ name: "login" });
        })
        .catch((error) => {
          this.loading = false;
          this.$toasted.global.notificate({
            message: error.response.data,
            type: "error",
          });
        });
    },
  },
};
</script>
